import portalAxios from "../axios/portalAxios";

export default class MobileUnitApi {
    static unassignLocation(token, customer_id, facility_id, location_id, node_sn) {
        return portalAxios.patch(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/${location_id}/nodes/${node_sn}/unassign`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static confirmUnassign(token, customer_id, facility_id, location_id, node_sn, otp, verify_token) {
        return portalAxios.patch(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/${location_id}/nodes/${node_sn}/unassign`,
            {
                token: verify_token,
                otp: otp,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static createLocation(
        token,
        customer_id,
        facility_id,
        node_sn,
        equipmentName,
        voltage,
        current,
        sf,
        freq,
        rpm,
        hp,
        poles,
        rotorBars,
        equipmentType,
        starter,
        vTapLocation,
        CTLocation,
    ) {
        return portalAxios.post(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/mobileunit`,
            {
                name: equipmentName,
                equipmentType: equipmentType,
                ...(hp && { npHp: hp }),
                npVoltage: voltage,
                npCurrent: current,
                ...(rpm && { npRpm: rpm }),
                ...(poles && { npPoles: poles }),
                ...(rotorBars && { npRotorBars: rotorBars }),
                ...(sf && { npServiceFactor: sf }),
                serialNumber: node_sn,
                starter: starter ?? "",
                ctLocation: CTLocation ?? "",
                voltageTapLocation: vTapLocation ?? "",
                ...(freq && { npLineFrequency: freq }),
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static verifyCreate(token, customer_id, facility_id, verify_token, otp) {
        return portalAxios.post(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/mobileunit`,
            {
                token: verify_token,
                otp: otp,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static editLocation(
        token,
        customer_id,
        facility_id,
        location_id,
        node_sn,
        equipmentName,
        voltage,
        current,
        sf,
        freq,
        rpm,
        hp,
        poles,
        rotorBars,
        equipmentType,
        starter,
        vTapLocation,
        CTLocation,
    ) {
        return portalAxios.patch(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/${location_id}`,
            {
                name: equipmentName,
                equipmentType: equipmentType,
                ...(hp && { npHp: hp }),
                npVoltage: voltage,
                npCurrent: current,
                ...(rpm && { npRpm: rpm }),
                ...(poles && { npPoles: poles }),
                ...(rotorBars && { npRotorBars: rotorBars }),
                ...(sf && { npServiceFactor: sf }),
                serialNumber: node_sn,
                starter: starter ?? "",
                ctLocation: CTLocation ?? "",
                voltageTapLocation: vTapLocation ?? "",
                ...(freq && { npLineFrequency: freq }),
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static confirmEdit(token, customer_id, facility_id, location_id, verify_token, otp) {
        return portalAxios.patch(
            `api/v2/customers/${customer_id}/facilities/${facility_id}/locations/${location_id}`,
            {
                token: verify_token,
                otp: otp,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
    }
    static getHistory(token, node_sn) {
        return portalAxios.get("", {
            params: {
                node_sn: node_sn,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
    static getMobileUnitList(token) {
        return portalAxios.get("api/nodes/mobileunits", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
}
